<ng-template #menuTemplate>

  <aside
    *ngIf="showMenu && authService.showSideBar" class="sidebar" #sidebar
    [ngStyle]="{  width: !isDense ? '220px' : '85px', 'overflow-y': !isDense ? 'auto' : 'hidden'}"
    (mouseenter)="mouseEnter()" (mouseleave)="mouseLeave()">

    <div class="sidebar-container">
      <div class="logo">
        <img src="/assets/icon/logo-blanco.png" alt="Logo" />
      </div>
      <nav class="menu">
        <ng-container *ngFor="let menuItem of menuItems">
          <ng-container *ngIf="isMenuItemVisible(menuItem)">
            <h2 *ngIf="!isDense">{{ menuItem.title | uppercase }}</h2>
            <span *ngIf="!isDense && menuItem.description">{{
              menuItem.description
            }}</span>
            <div class="divider" *ngIf="isDense"></div>
            <ul>
              <ng-container *ngFor="let link of menuItem.links; let i = index">
                <li *ngIf="showOptionMenu(link)">
                  <!-- <a class="no-select" [ngClass]="{active: link.id === selectedItem && !link.subMenu}"
                    (click)=" toggleSubMenu(link.id); this.selectedItem = link.id; goTo(link.url, link.id)">
                    <div class="menu-item-content">
                      <ion-icon [name]="link.icon"></ion-icon>
                      <span *ngIf="!isDense">{{ link.name }}</span>
                    </div>
                    <ion-icon *ngIf="link.subMenu && !isDense" class="chevron-icon" [name]="
                        isSubMenuOpen(link.id) ? 'chevron-down-outline' : 'chevron-forward-outline'"></ion-icon>
                  </a> -->
                  <a class="no-select" [ngClass]="{active: link.id === selectedItem && !link.subMenu}"
                    (click)=" toggleSubMenu(link.id); this.selectedItem = link.id; goTo(link.url, link.id)">

                    <div class="menu-item-content">
                      <ion-icon [name]="link.icon"></ion-icon>

                      <span *ngIf="!isDense">{{ link.name }}</span>

                      <!-- approved-bills counter-->
                      <ion-badge
                      *ngIf="link.id === 'approved-bills' && billService.pendingCount() > 0 && !isDense" class="menu-badge">
                        {{ billService.pendingCount() }}
                      </ion-badge>
                    </div>

                    <ion-icon *ngIf="link.subMenu && !isDense"
                              class="chevron-icon"
                              [name]="isSubMenuOpen(link.id) ? 'chevron-down-outline' : 'chevron-forward-outline'">
                    </ion-icon>
                  </a>
                  <ul *ngIf="link.subMenu && isSubMenuOpen(link.id) && !isDense">
                    <li *ngFor="let subLink of link.subMenu">
                      <a class="no-select" (click)="this.selectedItem = subLink.id; goTo2(subLink.url, subLink.id)"
                        [ngClass]="{ active: subLink.id === selectedItem }">
                        <ion-icon [name]="subLink.icon"></ion-icon>
                        <span *ngIf="!isDense"> {{ subLink.name }}</span>
                      </a>
                    </li>
                  </ul>
                </li>
              </ng-container>
            </ul>
          </ng-container>
        </ng-container>
      </nav>
    </div>
  </aside>
</ng-template>

<div *ngIf="!isMobile">
  <ng-container *ngTemplateOutlet="menuTemplate"></ng-container>
</div>

<ion-menu
  contentId="menuContent"
  side="start"
  menuId="first"
  type="overlay"
  *ngIf="isMobile"
  style="width: 220px;"
>
  <ion-content color="primary">
    <ng-container *ngTemplateOutlet="menuTemplate"></ng-container> </ion-content
></ion-menu>
<div style="display: flex; flex-direction: column">
  <ion-router-outlet
    id="menuContent"
    [ngStyle]="{
      'margin-left':
        !authService.showSideBar || isMobile
          ? '0px'
          : this.isExpanded
          ? '85px'
          : '220px'
    }"
  ></ion-router-outlet>
</div>
